import api from './api';

export const crmAPI = {
    // Partnerships
    listPartnerships: (workspace_id) =>
        api.get('/crm/partnerships', { params: { workspace_id } }),
    getPartnership: (id) => api.get(`/crm/partnerships/${id}`),
    createPartnership: (data) => api.post('/crm/partnerships', data),
    updatePartnership: (id, data) => api.put(`/crm/partnerships/${id}`, data),
    deletePartnership: (id) => api.delete(`/crm/partnerships/${id}`),

    // Contacts
    addContact: (partnership_id, data) =>
        api.post(`/crm/partnerships/${partnership_id}/contacts`, data),
    deleteContact: (id) => api.delete(`/crm/contacts/${id}`),

    // Leads
    listLeads: (workspace_id) => api.get('/crm/leads', { params: { workspace_id } }),
    getLead: (id) => api.get(`/crm/leads/${id}`),
    createLead: (data) => api.post('/crm/leads', data),
    deleteLead: (id) => api.delete(`/crm/leads/${id}`),

    // Clients
    listClients: (workspace_id) => api.get('/crm/clients', { params: { workspace_id } }),
    getClient: (id) => api.get(`/crm/clients/${id}`),
    createClient: (data) => api.post('/crm/clients', data),
    updateClient: (id, data) => api.put(`/crm/clients/${id}`, data),
    deleteClient: (id) => api.delete(`/crm/clients/${id}`),

    // Projects
    listProjects: (workspace_id, client_id) =>
        api.get('/crm/projects', { params: { workspace_id, client_id } }),
    getProject: (id) => api.get(`/crm/projects/${id}`),
    createProject: (data) => api.post('/crm/projects', data),
    updateProject: (id, data) => api.put(`/crm/projects/${id}`, data),
    deleteProject: (id) => api.delete(`/crm/projects/${id}`),

    // Payments
    listPayments: (project_id) => api.get(`/crm/projects/${project_id}/payments`),
    addPayment: (project_id, data) => api.post(`/crm/projects/${project_id}/payments`, data),
    deletePayment: (id) => api.delete(`/crm/payments/${id}`),

    // Workspace CRM members (for sales/AM picker)
    listMembers: (workspace_id) =>
        api.get('/crm/workspace-members', { params: { workspace_id } }),
};

export const formatIDR = (n) => {
    if (n == null) return '-';
    return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        maximumFractionDigits: 0,
    }).format(Number(n) || 0);
};

export const PROGRESS_OPTIONS = [
    { value: 'not_started', label: 'Belum Dimulai' },
    { value: 'in_progress', label: 'Berjalan' },
    { value: 'uat', label: 'UAT' },
    { value: 'completed', label: 'Selesai' },
    { value: 'on_hold', label: 'Ditahan' },
];

// Payment status: belum_bayar | dp | termin_N (N from 1..terms) | lunas
export const buildPaymentOptions = (terms) => {
    const opts = [
        { value: 'belum_bayar', label: 'Belum Bayar' },
        { value: 'dp', label: 'DP' },
    ];
    const n = Math.max(1, parseInt(terms, 10) || 1);
    for (let i = 1; i <= n; i++) {
        opts.push({ value: `termin_${i}`, label: `Termin ke-${i} (dari ${n})` });
    }
    opts.push({ value: 'lunas', label: 'Lunas' });
    return opts;
};

export const getPaymentLabel = (value, terms) => {
    const opts = buildPaymentOptions(terms);
    return opts.find((o) => o.value === value)?.label || value || '-';
};

export const getProgressLabel = (value) =>
    PROGRESS_OPTIONS.find((o) => o.value === value)?.label || value || '-';
